import { ConsumerModel } from '../models';
import { configConsumers } from '../config/config-consumers';
const {  pathname } = window.location;

export function getConsumer(): ConsumerModel {
	const consumer = configConsumers.find(iframe => iframe.paths.some(path => pathname.indexOf(path.name) !== -1));
	return {
		status: (consumer) ? true : false,
		utmSource: (consumer) ? consumer.source : 'Hypotheker',
		path: (consumer) ? consumer.paths.find(path => pathname.indexOf(path.name) !== -1) : { name: 'Hypotheker', links: { surplusInformation: '', canIAffordThisHouse: '' } }
	};
}
